module.exports = __webpack_public_path__ + "img/pasted imaaasage 0.8dc98615.png";